var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 18,
    viewBox: "0 0 21 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2154_19288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6741 0.0700684L10.4134 3.98563L8.15271 0.0700684H0.624268L10.4134 17.0251L20.2025 0.0700684H12.6741Z",
    fill: "#41B883"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6703 0.0700684L10.4096 3.98563L8.14892 0.0700684H4.53613L10.4096 10.2429L16.2831 0.0700684H12.6703Z",
    fill: "#34495E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2154_19288"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.5695,
    height: 16.9603,
    fill: "white",
    transform: "translate(0.637695 0.067627)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVue);
export default __webpack_public_path__ + "static/media/vue.2aa735de90113d266e381423834ff094.svg";
export { ForwardRef as ReactComponent };